import {ref} from "vue";

const search = ref({
    mainPage: {
        keyword: null,
        status: null,
        begin: null,
        end: null,
        range:null,
        type: 0,
        pageInfo: {
            total:0,
            current: 1,
            pageSize: 10,
        }
    }
})
export {search}